import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import SaasDetails from "./SaasDetails";

const SaasSinglePage: React.FC = () => {
    useEffect(() => {
            document.title = "AI Saas Product | Brain Machine AI";
          }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                        <PageTitle pageTitle="AI Saas Product" pagesub="AI Saas Product" />
                        <SaasDetails/>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default SaasSinglePage;
